import { getArray, getObject } from './firebase-database';

export const getUserPermission = userID => getObject(`project/back_office/users/${userID}/`);

export const getUsers = startAt => getArray(`user/`, 'userID', { startAt, orderByChild: 'email', limitToFirst: 10 });
